import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { exploreEtherData } from '../../../../Shared/ExploreDataFactory';

export interface ITransactionHistoryProps {
}

export function TransactionHistory(props: ITransactionHistoryProps) {
    const { pathname } = useLocation();
    const nftID = pathname.split("/")[2]

    const singleMatchGigData = exploreEtherData.find(data => data.id === JSON.parse(nftID!))


    return (
        <div className="mt-4 h-48 overflow-auto">
            {
                singleMatchGigData?.transactionHistory.map(data =>
                    <div key={data.id} className="mb-5">
                        <div className="flex justify-start items-center">
                            <h3 className="font-bold dark:font-normal text-cusBlack dark:text-white text-xs sm:text-sm md:text-base">{data.ammount} ETH</h3>
                            <span className="ml-2">
                                {data.growing
                                    ? <svg width={9} height={10} viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M7 14L7 3.83L10.59 7.41L12 6L6 0L0 6L1.41 7.41L5 3.83L5 14H7Z" fill="#B4EE73" />
                                    </svg>
                                    : <svg width={9} height={10} viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M5 0L5 10.17L1.41 6.59L0 8L6 14L12 8L10.59 6.59L7 10.17L7 0H5Z" fill="#FF7362" />
                                    </svg>
                                }
                            </span>

                            <p className="text-l-LightBlack dark:text-cusBlueWhite text-xxs md:text-xs ml-3">{data.time}</p>
                        </div>
                        <p className="xs:text-xxs sm:text-xs md:text-sm font-medium text-left dark:font-normal text-cusBlack dark:text-white mt-1 break-all">{data.token}</p>
                    </div>
                )
            }
        </div>
    );
}
